module.exports = __webpack_public_path__ + "static/media/facebook.0ca69aa8.svg";